export class CardBack {
  id: number;
  src: string;
  main: string;
  hwheel: string[];
  swheel: string[];
  lwheel: string[];
  hue: number;
  saturation: number;
  luminosity: number;
  updateWheels: boolean;
  origBack: string;
  holedBack: string;
  updatedBack: string;
  holes: CardHole[];
  hasKonvaImage: boolean = false;
  imageSave: any = null;
  hasKonvaGroup: boolean = false;
  groupSave: any = null;

  constructor(id: number, src: string, main: string, hwheel: string[], swheel: string[], lwheel: string[],
              updateWheels: boolean, origBack: string, holes: CardHole[]) {
    this.id = id;
    this.src = src;
    this.holedBack = src;
    this.main = main;
    this.hwheel = hwheel;
    this.swheel = swheel;
    this.lwheel = lwheel;
    this.updateWheels = updateWheels;
    this.origBack = src;
    this.updatedBack = src;
    this.holes = holes;
  }
}

export class CardHole {
  id: number;
  x: number;
  y: number;
  width: number;
  height: number;
  xPos: number = 0;
  yPos: number = 0;
  wPos: number = 0;
  hPos: number = 0;
  resizing: boolean;
  type: HoleType;
  option: number = 0;
  hadValsSet: boolean = false;
  borderWidth: number;
  borderColor: string;
  templateHole: boolean;

  hasKonvaGroup: boolean = false;
  konvaGroup: any;
  hasRectGroup: boolean = false;
  rectGroupSave: any;
  hasAnchorGroup: boolean = false;
  anchorGroupSave: any;

  constructor(id: number, x: number, y: number, width: number, height: number,
              resizing: boolean, type: HoleType, templateHole: boolean = false) {
    this.id = id;
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.resizing = resizing;
    this.type = type;
    this.borderWidth = 6;
    this.borderColor = '#000000';
    this.templateHole = templateHole;
  }
}

export enum HoleType {
  square,
  circle,
  star,
  triangle,
  diamond,
  none,
  spade,
  heart,
  club
}

let cardBacks = [
  new CardBack(0, "assets/0.png", '#ffffff', [], [],
    [], false, '', []),
  new CardBack(1, "assets/1.jpg", '#56caf5', [], [],
    [], false, '', []),
  new CardBack(2, "assets/2.jpg", '#bd202d', [], [],
    [], false, '', []),
  new CardBack(3, "assets/3.jpg", '#bdaf97', [], [],
    [], false, '', []),
  new CardBack(4, "assets/4.jpg", '#eb2128', [], [],
    [], false, '', []),
  new CardBack(5, "assets/5.jpg", '#00a64d', [], [],
    [], false, '', []),
  new CardBack(6, "assets/6.jpg", '#096e85', [], [],
    [], false, '', []),
  new CardBack(7, "assets/7.jpg", '#262a5e', [], [],
    [], false, '', []),
  new CardBack(8, "assets/8.jpg", '#eb3131', [], [],
    [], false, '', []),
  new CardBack(9, "assets/9.jpg", '#eb3131', [], [],
    [], false, '', []),
  new CardBack(10, "assets/10.jpg", '#242a5c', [], [],
    [], false, '', []),
  new CardBack(11, "assets/11.jpg", '#096e85', [], [],
    [], false, '', []),
  new CardBack(12, "assets/12.jpg", '#00a64d', [], [],
    [], false, '', []),
  new CardBack(13, "assets/13.jpg", '#b30000', [], [],
    [], false, '', []),
  new CardBack(14, "assets/14.jpg", '#527800', [], [],
    [], false, '', []),
  new CardBack(15, "assets/15.jpg", '#9a00bd', [], [],
    [], false, '', []),
  new CardBack(16, "assets/16.jpg", '#0068b8', [], [],
    [], false, '', []),
  new CardBack(17, "assets/17.jpg", '#00a8a5', [], [],
    [], false, '', []),
  new CardBack(18, "assets/18.jpg", '#ab0349', [], [],
    [], false, '', []),
  new CardBack(19, "assets/19.jpg", '#bd9a00', [], [],
    [], false, '', []),
  new CardBack(20, "assets/20.jpg", '#02bd85', [], [],
    [], false, '', []),
  new CardBack(21, "assets/21.jpg", '#9c3721', [], [],
    [], false, '', []),
  new CardBack(22, "assets/22.jpg", '#2b2b6e', [], [],
    [], false, '', []),
  new CardBack(23, "assets/23.jpg", '#fabb55', [], [],
    [], false, '', []),
  new CardBack(24, "assets/24.jpg", '#472f66', [], [],
    [], false, '', []),
  new CardBack(25, "assets/25.jpg", '#fabc8c', [], [],
    [], false, '', []),
  new CardBack(26, "assets/26.jpg", '#5a5a5c', [], [],
    [], false, '', []),
  new CardBack(27, "assets/27.jpg", '#307369', [], [],
    [], false, '', []),
  new CardBack(28, "assets/28.jpg", '#c2151b', [], [],
    [], false, '', []),
  new CardBack(29, "assets/29.jpg", '#00548c', [], [],
    [], false, '', []),
  new CardBack(30, "assets/30.jpg", '#005494', [], [],
    [], false, '', []),
  new CardBack(31, "assets/31.jpg", '#c9121b', [], [],
    [], false, '', []),
  new CardBack(32, "assets/32.jpg", '#376e6c', [], [],
    [], false, '', []),
  new CardBack(33, "assets/33.jpg", '#555459', [], [],
    [], false, '', []),
  new CardBack(34, "assets/34.png", '#3387c1', [], [],
    [], false, '', []),
  new CardBack(35, "assets/35.png", '#7ccfbc', [], [],
    [], false, '', []),
  new CardBack(36, "assets/36.png", '#00897c', [], [],
    [], false, '', []),
  new CardBack(37, "assets/37.png", '#fbb040', [], [],
    [], false, '', []),
  new CardBack(38, "assets/38.png", '#993dc4', [], [],
    [], false, '', []),
  new CardBack(39, "assets/39.png", '#a03043', [], [],
    [], false, '', []),
  new CardBack(40, "assets/40.png", '#324293', [], [],
    [], false, '', []),
  new CardBack(41, "assets/41.png", '#13b7e9', [], [],
    [], false, '', []),
  new CardBack(42, "assets/42.png", '#fbd062', [], [],
    [], false, '', []),
  new CardBack(43, "assets/43.png", '#ff8506', [], [],
    [], false, '', []),
  new CardBack(44, "assets/44.png", '#fc9419', [], [],
    [], false, '', []),
  new CardBack(45, "assets/45.png", '#ed5197', [], [],
    [], false, '', []),
  new CardBack(46, "assets/46.png", '#12d8cd', [], [],
    [], false, '', []),
  new CardBack(47, "assets/47.png", '#e25dc6', [], [],
    [], false, '', []),
  new CardBack(48, "assets/48.png", '#26aee9', [], [],
    [], false, '', []),
  new CardBack(49, "assets/49.png", '#ffcf3b', [], [],
    [], false, '', []),
  new CardBack(50, "assets/50.png", '#2de4bf', [], [],
    [], false, '', []),
  new CardBack(51, "assets/51.png", '#ff717f', [], [],
    [], false, '', []),
  new CardBack(52, "assets/52.png", '#ffa539', [], [],
    [], false, '', []),
  new CardBack(53, "assets/53.png", '#ec3e6c', [], [],
    [], false, '', []),
  new CardBack(54, "assets/54.png", '#12d8cd', [], [],
    [], false, '', []),
  new CardBack(55, "assets/55.png", '#ed5197', [], [],
    [], false, '', []),
  new CardBack(56, "assets/56.png", '#e25dc6', [], [],
    [], false, '', [])
];

export default cardBacks;
